import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as DTOS from "../../../../FeralScan.dtos";
import { IAppState } from '../../../../app';
import { IBasePageProps } from '../../configuration/IConfiguration';
import ActivateAccount from '../../../Users/ActivateAccount';
import * as UserActionCreators from "../../../../actions/user.actions";

interface IPageActivateAccountProps {
}

interface IPageActivateAccountRouteParams {
}

interface IPageActivateAccountQueryParams {
    activateAccountToken: string;
}

interface IPageActivateAccountListMapped {
    activateAccount: typeof UserActionCreators.activateAccount
}

type PageActivateAccountProps = IBasePageProps<IPageActivateAccountRouteParams, IPageActivateAccountQueryParams> & IPageActivateAccountListMapped & IPageActivateAccountProps;

class PageActivateAccount extends React.Component<PageActivateAccountProps, any> {
    constructor(props, context) {
        super(props, context);

        this.state = { activatingAccount: false }

        this.activateAccount = this.activateAccount.bind(this);
    }

    activateAccount(token: string) {
        if (!this.state.activatingAccount)
            this.props.activateAccount(token);

        this.setState({ activatingAccount: true });
    }

    render() {
        return (<div className="mx-lg-3 mt-3 col-md-6 col-12">
            <h3>Account Activation</h3>
            <ActivateAccount
                currentUser={this.props.currentUser}
                loginActive={this.props.loginActive}
                activateAccount={this.activateAccount}
                activateAccountToken={this.props.queryParams.activateAccountToken}
            />
        </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageActivateAccountProps) => {

    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        activateAccount: UserActionCreators.activateAccount
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PageActivateAccount);